import { Flex, Text } from '@chakra-ui/react';
import { faCalendar } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { OutlineCard } from '@morressier/alembic';
import { useQuery } from '@tanstack/react-query';
import { fetchPreProductionFeedback } from 'src/api/queries';
import MultilineText from 'src/components/MultilineText';
import { formatDate } from 'src/utils/date';

interface PreProductionFeedbackProps {
  submissionId: string;
}

export const PreProductionFeedback = ({
  submissionId
}: PreProductionFeedbackProps) => {
  const { data: feedbackResponse } = useQuery({
    queryKey: ['PreProductionfeedback', { submissionId }],
    queryFn: () => fetchPreProductionFeedback(submissionId, 'author'),
    retry: 0
  });
  const EmptyChangeRequest = () => {
    return (
      <Flex flexDirection="column" gap={8} textAlign="center" paddingBottom={8}>
        <Flex flexDirection="column" gap={2}>
          <Text textStyle="textBody" paddingX={2}>
            There are no updates required for your submission as of now.
          </Text>
        </Flex>
      </Flex>
    );
  };
  const { dateEntered, editorComment } = feedbackResponse ?? {};
  return (
    <OutlineCard padding={4} width="100%">
      {feedbackResponse ? (
        <Flex flexDirection="column" gap={6}>
          <Text textStyle="headingSection">Provisional Acceptance Feedback</Text>
          {dateEntered && (
            <Flex flexDirection="column" gap={2}>
              <Flex flexDirection="row" gap={2} alignItems="center">
                <FontAwesomeIcon icon={faCalendar} />
                Received {formatDate(new Date(dateEntered))}
              </Flex>
            </Flex>
          )}
          {editorComment && (
            <Flex gap={2} flexDirection={'column'}>
              <Text textStyle="headingGroup">Editor’s comment</Text>
              <MultilineText textStyle="textBody" text={editorComment} />
            </Flex>
          )}
        </Flex>
      ) : (
        <EmptyChangeRequest />
      )}
    </OutlineCard>
  );
};
